import React from "react";
import * as AlfredoStyles from "../../../styles/global/global";
import * as AlfredoComponents from "../../../components";

const OrdersReport: React.FC = () => {
  return (
    <AlfredoStyles.Container>
      <AlfredoComponents.Breadcrumb />
      <AlfredoStyles.FlexContainer>
        <AlfredoStyles.FlexItem>
          <AlfredoComponents.OrderReport />
        </AlfredoStyles.FlexItem>
      </AlfredoStyles.FlexContainer>
    </AlfredoStyles.Container>
  );
};

export default OrdersReport;
